import { EntityUpdater } from "./EntitiyUpdater";

export class UmpireUpdater extends EntityUpdater {
    updateUmpires(adding, deleting) {
        let { umpiresObject } = this.data;

        if (deleting.length > 0) {
            umpiresObject = this.processDeletions(deleting, umpiresObject);
        }

        if (adding.length > 0) {
            umpiresObject = this.processAdditions(
                adding,
                umpiresObject,
                (item) => ({
                    contact: item.id,
                    dhbMatch: this.data.id,
                    role: 0,
                })
            );
        }

        this.data.umpiresObject = umpiresObject;
        this.data.isUmpireChange = true;
        return this.data;
    }
}
